<template>
  <div class="downloadContainer">
    <div>
      <img src="../img/caijing.png" class="downloadContent" />
      <img src="../img/tiyan.png" class="downloadButton" v-on:click="toLink" />
    </div>
    <div class="downloadInfo" v-if="coverShow" v-on:click="coverClick">
      <img src="../img/openType.png" />
    </div>
  </div>
</template>

<script>
  import {isAndroidAndNobrowser, isIOS} from "../api/browser.js"
  export default {
    name: 'download',
    data(){
      return{
        coverShow: false
      };
    },
    methods:{
      coverClick(){
        this.coverShow = false;
      },
      toLink(){
        if(isAndroidAndNobrowser()){
          //遮罩提示浏览器打开
          this.coverShow = true;
          return false;
        }

        if (!isIOS()) {
          //android,在浏览器环境中
          window.location.href = downloadLinkAndroid;
          window.setTimeout(() => {
            window.location.href = downloadLinkAll;
          }, 2000);
        } else {
          // ios
          window.location.href = downloadLinkIOS;
        }
        return true;
      }
    }
  }
</script>

<style scoped>
  .downloadContainer {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .downloadContent {
    width: 100%;
  }
  .downloadButton {
    width: 90px;
    position: absolute;
    top: 50%;
    right: 5%;
    margin-top: -18px;
  }
  .downloadInfo{
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 9999;
  }
  .downloadInfo img {
    margin-top: 10px;
    width: 270px;
    float: right;
    margin-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/download.vue